import { render, staticRenderFns } from "./MonsterLeads.vue?vue&type=template&id=2270e28a"
import script from "./MonsterLeads.vue?vue&type=script&lang=js"
export * from "./MonsterLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports